var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 9.721C.5 8.156 3.617 3 10.5 3s10 5.155 10 6.721-3.117 6.722-10 6.722-10-5.157-10-6.722zm.984 0c0 1.177 2.8 5.738 9.017 5.738s9.016-4.561 9.016-5.738-2.8-5.736-9.016-5.736-9.017 4.561-9.017 5.736z",
    stroke: "transparent",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.502 13.823a4.1 4.1 0 114.1-4.1 4.1 4.1 0 01-4.1 4.1zm0-7.213a3.115 3.115 0 103.115 3.115 3.118 3.118 0 00-3.115-3.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5 0h20v20H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/Visibility.c1b917c272d70c43de1346b1545f54cd.svg";
export { ForwardRef as ReactComponent };